module.exports = __webpack_public_path__ + "img/unrevealed.36df81f9.png";